import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetEmployees } from 'api-hooks/employee';
import { NavigationRoutes } from 'common/constants';
import { useRouter } from 'next/router';
import React from 'react';

interface EmployeeSelectProps extends SelectProps {}

export default function EmployeeSelect(props: EmployeeSelectProps) {
  const { pathname } = useRouter();
  const roles = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.PassportReport:
      case NavigationRoutes.VisaReport:
      case NavigationRoutes.ApecCardReport:
      case NavigationRoutes.InsuranceReport:
        return ['docs'].join('|');
      case NavigationRoutes.FlightReport:
        return ['flight'].join('|');
      case NavigationRoutes.HotelReport:
        return ['hotel'].join('|');
      default:
        return undefined;
    }
  }, [pathname]);

  const query = useGetEmployees({
    params: {
      limit: -1,
      filter: {
        roles,
      },
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...props}
      data={data}
      disabled={query.isLoading || props.disabled}
    />
  );
}
